import { Injectable } from '@angular/core';
import { TrackingService } from '@shared/core/services/tracking.service';
import { randomByTimestamp } from '@shared/core/utils';
import { VimCoreTrackingData } from '../../../../vendor/tracking';

interface TrackingUseCaseConfig {
  useCaseType: string;
  useCaseId?: number;
  personId?: number;
  educationServiceId?: number;
}

export interface TrackingUseCaseBaseData {
  target: string;
  type: 'control' | 'widget' | 'field' | 'form' | 'page';
  action: 'loaded' | 'showed' | 'submitted' | 'clicked' | 'hide';
  step: 'first' | 'middle' | 'last';
}

interface TrackingUseCaseData extends TrackingUseCaseBaseData, VimCoreTrackingData {}

@Injectable()
export class TrackingUseCaseService {
  private config: TrackingUseCaseConfig;

  constructor(private trackingService: TrackingService) {}

  setConfig(config: TrackingUseCaseConfig): void {
    this.setUseCaseId();

    this.config = {
      ...this.config,
      ...config,
    };
  }

  setUseCaseId(): void {
    this.config = {
      ...this.config,
      useCaseId: randomByTimestamp(),
    };
  }

  send(data: TrackingUseCaseData): void {
    const event = `${data.target}:${data.action}:${data.type}`;

    if (!['first', 'middle', 'last'].includes(data.step)) {
      throw new Error(`TrackingUseCaseService: wrong step: ${data.step}`);
    }

    this.trackingService.track(event, {
      ...this.config,
      ...data,
    });
  }
}
